import styled from 'styled-components';

export const FirstLineType = styled.div`
  margin-bottom: 8px;
`;
